$ = jQuery.noConflict();


$(function () {
	jQuery.event.special.touchstart = {
		setup: function( _, ns, handle ) {
			this.addEventListener("touchstart", handle, { passive: ns.includes("noPreventDefault") });
		}
	};
	jQuery.event.special.touchmove = {
		setup: function( _, ns, handle ) {
			this.addEventListener("touchmove", handle, { passive: ns.includes("noPreventDefault") });
		}
	};
	jQuery.event.special.wheel = {
		setup: function( _, ns, handle ){
			this.addEventListener("wheel", handle, { passive: true });
		}
	};
	jQuery.event.special.mousewheel = {
		setup: function( _, ns, handle ){
			this.addEventListener("mousewheel", handle, { passive: true });
		}
	};

	// Vars
	isTouch = Modernizr.touchevents;

	// Utils
	madeByMcube();
	initDocEvents();
	initMatchHeight();
	initLinks();
	initFitvids();

	// Components
	initMainNav();
	initToggleNote();
	initSidebarToggle();
	initTilt();
	initForms();
	initFormGeneration();
	initPhoneInputs();
	initBlogNav();
	initScrollRevealAnimations();
	initNavBannerClub();

	initAjaxLoadMore();
	initVideoPlayers();
	initSchedule();
	initScheduleMobile();
	initSliders();
	initAlerts();
	initPopup();
	initJobFilters();
	initMaps();
	initFilteredListings();
	initLazyload();
	initYoutubeVideos();
	RealTimeCounter();
	initSimpleToggle();
	initWellnessButtons();
	initPageTarifV2();
	initAppointmentSelector();

	initLandingStandalone();
});

function resizeHandler() {
	matchHeightReset();
}

const headerMain = document.querySelector(".header-main");
const headerMainHeight = headerMain.clientHeight;
const blogScrollProgressBar = document.querySelector("#blogProgressBar");
const ctaFixedButton = document.querySelector(".cta-fixed-button");
const footerHeight = document.querySelector(".footer-main").clientHeight;
const relatedArticles = document.querySelector(".related");
let sidebarHeight = 0;
if (relatedArticles){
	sidebarHeight = relatedArticles.clientHeight;
}

function scrollHandler() {
	if (ctaFixedButton) {
		initCtaFixedButton();
	}

	if (blogScrollProgressBar) {
		scrollIndicator();
	}

	if (window.scrollY > headerMainHeight) {
		$('body').addClass('header-is-hidden header-is-blocked');
	} else {
		$('body').removeClass('header-is-hidden header-is-blocked');

	}
}
